// Painel Super Master > ambiente da câmera WY02 (JT/T 808) — proxy
// autenticado para o servidor de teste isolado (ver
// gpsdrive-backend-release-fase1-2/src/jt808-camera/). Sessão de
// plataforma (platformGet/platformFetchBlob), mesmo padrão de
// notification-sounds/app-releases — não é feature de empresa comum.
import { GPSDRIVE_API_URL } from "@/lib/api/gpsdrive-client";
import { getPlatformAccessToken, platformFetchBlob, platformGet, platformPostBinary } from "@/lib/api/gpsdrive-platform-client";

export interface Jt808CameraPhoto {
  file: string;
  sizeBytes: number;
  modifiedAt: string;
  url: string;
}

export const jt808CameraService = {
  listPhotos: (imei: string) => platformGet<Jt808CameraPhoto[]>(`/api/v1/jt808-camera/${imei}/photos`),
  fetchPhotoBlob: (photo: Jt808CameraPhoto) => platformFetchBlob(photo.url),
  // URL absoluta (mpegts.js precisa fazer sua própria requisição HTTP, não
  // passa pelo platformRequest) — token vai via header custom (suportado
  // pelo carregador padrão do mpegts.js), não como query string, pra não
  // vazar o JWT em log de acesso do Nginx.
  // channel: 1 = externa, 2 = interna (WY02, confirmado em campo 2026-09-15).
  getLiveVideoRequest: (imei: string, channel: 1 | 2): { url: string; headers: Record<string, string> } => ({
    url: `${GPSDRIVE_API_URL}/api/v1/jt808-camera/${imei}/live.flv?channel=${channel}`,
    headers: getPlatformAccessToken() ? { Authorization: `Bearer ${getPlatformAccessToken()}` } : {},
  }),
  // EXPERIMENTAL — locução (push-to-talk). audioMuLaw: bytes μ-law 8kHz
  // mono já codificados (ver src/lib/mulaw-encoder.ts). Requer vídeo ao
  // vivo já em andamento nesse IMEI (mesma conexão 1078).
  sendTalkAudio: (imei: string, audioMuLaw: Uint8Array) =>
    platformPostBinary<{ ok: boolean; message: string }>(
      `/api/v1/jt808-camera/${imei}/talk`,
      new Blob([audioMuLaw.slice().buffer as ArrayBuffer]),
      "application/octet-stream",
    ),
};
